import { t } from "@lingui/macro";
import graphql from "babel-plugin-relay/macro";

import { useToast } from "@whoosh/design-system/src/components/overlay/Toast/useToast";

import { useMutationWithError } from "../../../utils/hooks/useMutationWithError";
import {
  DeleteEventSignUpInput,
  useDeleteEventSignUpMutation,
  useDeleteEventSignUpMutation$data,
} from "./__generated__/useDeleteEventSignUpMutation.graphql";

export const useDeleteEventSignUp = (successCallback?: () => void) => {
  const { showToast } = useToast();

  const [deleteEventSignUp, isAdding] =
    useMutationWithError<useDeleteEventSignUpMutation>(
      useDeleteEventSignUpMutationString
    );

  const onCompleted = (res: useDeleteEventSignUpMutation$data) => {
    if (res.responsePayload?.success) {
      showToast({
        title: t`Signup Successfully Deleted.`,
        semanticStyle: "success",
        toastId: "delete-signup-success",
      });
      successCallback?.();
    }
  };

  const onCompletedErrorCustom = () => {
    showToast({
      title: t`Sorry. An error occurred while deleting your signup.`,
      toastId: "delete-signup-error",
      semanticStyle: "error",
    });

    return [];
  };

  const handleDeleteEventSignUp = (
    input: DeleteEventSignUpInput,
    memberId: string
  ) => {
    deleteEventSignUp({
      variables: { input, memberId },
      onCompleted,
      onCompletedErrorCustom,
    });
  };

  return [handleDeleteEventSignUp, isAdding] as const;
};

const useDeleteEventSignUpMutationString = graphql`
  mutation useDeleteEventSignUpMutation(
    $input: DeleteEventSignUpInput!
    $memberId: ID!
  ) {
    responsePayload: deleteEventSignUp(input: $input) {
      errors {
        field
        code
        message
      }
      success
      event {
        id
        accessStatusForClient(clientId: $memberId)
        signUpStatusForClient(clientId: $memberId)
        ...useCurrentSignUp_event
        eventSeries {
          events {
            edges {
              node {
                accessStatusForClient(clientId: $memberId)
                signUpStatusForClient(clientId: $memberId)
              }
            }
          }
        }
        ...EventDetailAttendeesList
        ...EventDetailGroupDisplay_event
      }
    }
  }
`;
